import { theme } from "@project/shared/src/theme";
import { styled } from "linaria/lib/react";
const Card = /*#__PURE__*/styled("article")({
  name: "Card",
  class: "cpeplbj"
});

const StepCard = ({
  image,
  title,
  desc,
  index
}) => {
  return <Card>
      <img src={image} />
      <p className="step">STEP {index}</p>
      <p className="title">{title}</p>
      <p className="desc">{desc}</p>
    </Card>;
};

export { StepCard };

require("./index.linaria.module.css!=!../../../../../node_modules/linaria/lib/outputCssLoader.js?cacheProvider=!./index.tsx");